$dependencyManager.addDependencyCallback('plyr', () => {

  class VideoLoader {
    constructor() {
      
    }

    load(container, videoUrl, autoplay = false) {
      this.container = jQuery(container);
      this.videoUrl = videoUrl;
      this.autoplay = autoplay;

      // Initialize the video player
      return this.initPlayer();
    }

    initPlayer() {
      this.container.empty();

      let videoElement;
      const uniqueId = 'plyr-' + Math.random().toString(36).substr(2, 9);

      if (this.isVimeoUrl(this.videoUrl)) {
        // Create a Vimeo video element using jQuery
        videoElement = jQuery('<div>', {
          'id': uniqueId,
          'data-plyr-provider': 'vimeo',
          'data-plyr-embed-id': this.extractVimeoId(this.videoUrl)
        });
      } else if (this.isMp4Url(this.videoUrl)) {
        // Create an MP4 video element using jQuery
        videoElement = jQuery('<video>', {
          'id': uniqueId,
          src: this.videoUrl,
          controls: true,
          autoplay: this.autoplay,
          muted: this.autoplay
        });
      } else {
        console.error('Unsupported video URL:', this.videoUrl);
        return Promise.reject('Unsupported video URL');
      }

      this.container.append(videoElement);

      return new Promise((resolve, reject) => {
        try {
          const player = new Plyr('#' + uniqueId, {
            storage: { enabled: false },
            autoplay: this.autoplay,
            muted: this.autoplay
          });

          if (this.isVimeoUrl(this.videoUrl) && this.autoplay === true) {
            player.on('ready', () => {
              player.muted = true;
              player.play().catch(e => console.warn("Autoplay prevented:", e));
              resolve(player);
            });
            player.on('error', (event) => {
              console.error('Plyr Vimeo Error:', event);
              reject(event);
            });
          } else if (this.isMp4Url(this.videoUrl) && this.autoplay === true) {
             player.on('ready', () => {
                player.muted = true;
                resolve(player);
             });
             player.on('error', (event) => {
               console.error('Plyr MP4 Error:', event);
               reject(event);
             });
          }
          else {
             player.on('ready', () => {
                resolve(player);
             });
             player.on('error', (event) => {
               console.error('Plyr Error:', event);
               reject(event);
             });
          }

        } catch (error) {
            console.error('Error initializing Plyr:', error);
            reject(error);
        }
      });
    }

    isVimeoUrl(url) {
      const vimeoRegex = /(?:https?:\/\/)?(?:www\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:$|\/|\?)/;
      return vimeoRegex.test(url);
    }

    isMp4Url(url) {
      const mp4Regex = /\.mp4$/i;
      return mp4Regex.test(url);
    }

    extractVimeoId(url) {
      // Extract the Vimeo video ID from the URL
      const vimeoRegex = /(?:https?:\/\/)?(?:www\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:$|\/|\?)/;
      const match = url.match(vimeoRegex);
      return match ? match[1] : null;
    }
  }

  // Expose the VideoLoader class globally
  window.VideoLoader = VideoLoader;

}, hasPriority = true);